<template>
  <div>
    <Datepicker
      :input-class="'input-datepicker'"
      :wrapper-class="'datepicker'"
      :format="timeFormat"
      :placeholder="timeFormat"
      v-model="selected"
    />
    <font-awesome-icon :icon="'calendar'" class="calendar-icon"/>
  </div>
</template>

<script lang="ts">
import Datepicker from 'vuejs-datepicker'
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator'
import moment, { Moment } from 'moment'

@Component({
  components: { Datepicker },
})
export default class DateInput extends Vue {
  @Prop() value!: Moment

  timeFormat: string = 'yyyy-MM-dd'

  private get selected() {
    return this.value?.toString()
  }

  private set selected(date: string) {
    const d = (date) ? moment(date, this.timeFormat) : null
    if (moment(date, this.timeFormat).year() <= 2023) {
      this.$bvModal.msgBoxOk('Error - This data from 2021 to 2023 cannot be registered.');
      return
    }
    this.$emit('input', d)
  }
}
</script>

<style scoped>
.datepicker {
  position: static;
  display: inline-block;
  vertical-align: middle;
}
.calendar-icon {
  margin-left: -1.5em;
  display: inline;
  vertical-align: middle;
  pointer-events: none;
}
</style>

<style>
input.input-datepicker[type="text"] {
  padding: 5px;
  border: 1px solid hsl(215, 8%, 69%);
  border-radius: 30px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
